import { LoadingButton } from '@mui/lab'
import { Box, Stack } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'

import Error from '~/components/error'
import LoadingWithBackdrop from '~/components/loadingWithBackdrop'
import AuthFormsLogo from '~/features/auth/components/authFormsLogo'
import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import { EPartnerDomains } from '~/features/partners/models'
import EEnvironmentVariables from '~/models/config'
import AuthService from '~/services/auth'
import asyncTryCatch from '~/utils/misc'

function OidcSignIn() {
  const [errorMessage, setErrorMessage] = useState('')
  const { partner } = usePartnerCentralized()
  const isAutoSignIn = [
    EPartnerDomains.virtualGurus,
    EPartnerDomains.whiteLabelChris,
  ].includes(partner.domain as EPartnerDomains)

  const handleSignInOidc = useCallback(() => {
    asyncTryCatch({
      fn: async () => {
        await AuthService.signInOidc()
      },
      errorFn: setErrorMessage,
    })
  }, [])

  useEffect(() => {
    if (isAutoSignIn) {
      handleSignInOidc()
    }
  }, [handleSignInOidc, isAutoSignIn])

  if (isAutoSignIn) {
    return <LoadingWithBackdrop show />
  }

  return (
    <Box>
      <Stack
        spacing={2}
        sx={{
          alignItems: 'center',
        }}
      >
        <AuthFormsLogo />

        {import.meta.env[EEnvironmentVariables.VITE_OIDC_NAME] && (
          <LoadingButton onClick={handleSignInOidc} variant="secondary">
            Sign In
          </LoadingButton>
        )}
        <Error message={errorMessage} />
      </Stack>
    </Box>
  )
}

export default OidcSignIn
